/* Automatically generated file, do not update manually */
import type { Provider } from '@ethersproject/abstract-provider';
import { Contract, Signer } from 'ethers';
import { useMemo } from 'react';

import abi from 'libs/contracts/generated/infos/abis/ResilientOracle.json';
import { ResilientOracle } from 'libs/contracts/generated/infos/contractTypes';
import { getUniqueContractAddress } from 'libs/contracts/utilities/getUniqueContractAddress';
import { useChainId, useProvider, useSigner } from 'libs/wallet';
import { ChainId } from 'types';

interface GetResilientOracleContractAddressInput {
  chainId: ChainId;
}

export const getResilientOracleContractAddress = ({
  chainId,
}: GetResilientOracleContractAddressInput) =>
  getUniqueContractAddress({ name: 'ResilientOracle', chainId });

export const useGetResilientOracleContractAddress = () => {
  const { chainId } = useChainId();

  return useMemo(
    () =>
      getResilientOracleContractAddress({
        chainId,
      }),
    [chainId],
  );
};

interface GetResilientOracleContractInput {
  chainId: ChainId;
  signerOrProvider: Signer | Provider;
}

export const getResilientOracleContract = ({
  chainId,
  signerOrProvider,
}: GetResilientOracleContractInput) => {
  const address = getResilientOracleContractAddress({ chainId });
  return address ? (new Contract(address, abi, signerOrProvider) as ResilientOracle) : undefined;
};

interface UseGetResilientOracleContractInput {
  passSigner?: boolean;
  chainId?: ChainId;
}

export const useGetResilientOracleContract = (input?: UseGetResilientOracleContractInput) => {
  const { chainId: currentChainId } = useChainId();
  const chainId = input?.chainId || currentChainId;

  const { provider } = useProvider({ chainId });
  const { signer } = useSigner({ chainId });
  const signerOrProvider = input?.passSigner ? signer : provider;

  return useMemo(
    () =>
      signerOrProvider
        ? getResilientOracleContract({
            chainId,
            signerOrProvider,
          })
        : undefined,
    [signerOrProvider, chainId],
  );
};
